"use client";

import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from "react";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { isActive } from "@/components/header/nav-utils";
interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  activeClassName?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
const NavLinkInner: React.FC<NavLinkProps> = t0 => {
  const $ = _c(10);
  const {
    href,
    children,
    className: t1,
    activeClassName: t2,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const activeClassName = t2 === undefined ? "" : t2;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const active = isActive(href, pathname, searchParams);
  const t3 = active ? activeClassName : "";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = ["w-full", className, t3].filter(Boolean);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const computedClassName = t4.join(" ");
  const t5 = href || "#";
  let t6;
  if ($[3] !== children || $[4] !== computedClassName || $[5] !== onClick || $[6] !== onMouseEnter || $[7] !== onMouseLeave || $[8] !== t5) {
    t6 = <Link href={t5} className={computedClassName} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} prefetch={true}>{children}</Link>;
    $[3] = children;
    $[4] = computedClassName;
    $[5] = onClick;
    $[6] = onMouseEnter;
    $[7] = onMouseLeave;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
const NavLink: React.FC<NavLinkProps> = props => {
  const $ = _c(12);
  const t0 = props.className || "";
  let t1;
  if ($[0] !== t0) {
    t1 = ["w-full", t0].filter(Boolean);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fallbackClassName = t1.join(" ");
  const t2 = props.href || "#";
  let t3;
  if ($[2] !== fallbackClassName || $[3] !== props.children || $[4] !== props.onClick || $[5] !== t2) {
    t3 = <Link href={t2} className={fallbackClassName} onClick={props.onClick}>{props.children}</Link>;
    $[2] = fallbackClassName;
    $[3] = props.children;
    $[4] = props.onClick;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props) {
    t4 = <NavLinkInner {...props} />;
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <Suspense fallback={t3}>{t4}</Suspense>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default NavLink;